export default class OurProcess {


	// Constructor
	constructor(element) {

		this.element = element;
		this.index = 0;

		this.buttonNext = this.element.querySelector('.prev-next-buttons--next');
		this.buttonPrev = this.element.querySelector('.prev-next-buttons--prev');
		this.images = Array.prototype.slice.call(this.element.querySelectorAll('.section-our-process--image'), 0);
		this.text = Array.prototype.slice.call(this.element.querySelectorAll('.section-our-process--text p'), 0);

		this.buttonClick = this.buttonClick.bind(this);

	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.buttonNext;
		delete this.buttonPrev;
		delete this.element;
		delete this.images;
		delete this.index;
		delete this.text;
	}
	enable() {
		this.disable();
		this.buttonNext.addEventListener('click', this.buttonClick);
		this.buttonPrev.addEventListener('click', this.buttonClick);
	}
	disable() {
		this.buttonNext.removeEventListener('click', this.buttonClick);
		this.buttonPrev.removeEventListener('click', this.buttonClick);
	}


	// Event Handlers
	buttonClick(event) {
		event.preventDefault();
		if (event.currentTarget === this.buttonNext) {
			this.index += 1;
			if (this.index >= this.images.length) {
				this.index = 0;
			}
		}
		if (event.currentTarget === this.buttonPrev) {
			this.index -= 1;
			if (this.index < 0) {
				this.index = this.images.length - 1;
			}
		}
		var i, l;
		for (i=0, l=this.images.length; i<l; i++) {
			if (i === this.index) {
				this.images[i].classList.add('active');
			} else {
				this.images[i].classList.remove('active');
			}
		}
		for (i=0, l=this.text.length; i<l; i++) {
			if (i === this.index) {
				this.text[i].classList.add('active');
			} else {
				this.text[i].classList.remove('active');
			}
		}
	}

}
